import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../css/AdminManagement.css';
import { SERVER_URL } from '../../config/config'; 
import ConfirmPopup from './side/ConfirmPopup';
import ErrorPopup from './side/ErrorPopup';
import { useNavigate } from 'react-router-dom';

function ModelDetailModal({ model, onClose }) {
  const [tab, setTab] = useState('dataset');
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [datasets, setDatasets] = useState([]); // 모든 데이터셋 정보
  const [selecting, setSelecting] = useState(false);
  const [selectError, setSelectError] = useState(null);
  const [selectSuccess, setSelectSuccess] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // 모델 상세 정보 요청
    const fetchDetail = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(`${SERVER_URL}/admin/ai/model/detail?model_id=${model.model_id}`);
        setDetail(res.data);
      } catch (e) {
        setDetail(null);
        setError('상세 정보를 불러오지 못했습니다.');
      }
      setLoading(false);
    };
    fetchDetail();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // 모든 데이터셋 정보 요청
    const fetchDatasets = async () => {
      try {
        const res = await axios.get(`${SERVER_URL}/admin/dataset/all`);
        setDatasets(res.data.data || []);
      } catch (e) {
        setDatasets([]);
      }
    };
    fetchDatasets();
  }, []);

  // 실행 모델로 선택 함수 (팝업에서 확인 시 실행)
  const handleSelectModel = async () => {
    setSelecting(true);
    setSelectError(null);
    try {
      const params = new URLSearchParams();
      console.log(model.model_id);
      params.append('admin_id', localStorage.getItem('adminId'));
      params.append('model_id', model.model_id);
      await axios.post(`${SERVER_URL}/admin/ai/model/select`, params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      setSelectSuccess(true);
      // VersionManagement로 이동 후 새로고침
    } catch (e) {
      setSelectError('실행 모델 선택에 실패했습니다.');
    }
    // detail 상태의 selected 값 true로 업데이트
    setDetail(prev => ({
      ...prev,
      selected: true
    }));
    setSelecting(false);
    setShowConfirm(false);
  };

  const handleDeleteModel = async () => {
    try {
      await axios.delete(`${SERVER_URL}/admin/ai/model/delete?model_id=${model.model_id}&admin_id=${localStorage.getItem('adminId')}`);
      setShowDeleteConfirm(false);
      setDeleteSuccess(true);
    } catch (e) {
      setSelectError('모델 삭제에 실패했습니다.');
    }
  };

  if (loading) return <div className="modal-overlay"><div className="modal-content">로딩 중...</div></div>;
  if (error) return <div className="modal-overlay"><div className="modal-content">{error}</div></div>;
  if (!detail) return null;

  // 파라미터를 key-value 쌍 배열로 변환
  const paramEntries = detail.params ? Object.entries(detail.params) : [];
  const selectedIds = (detail.dataset_ids || []).map(String); // 선택된 데이터셋 id (string)

  return (
    <div className="modal-overlay" style={{ 
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2000,
      background: 'rgba(34,34,34,0.15)',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 24,
        padding: '40px 32px 32px 32px',
        minWidth: 720,
        maxWidth: '90vw',
        overflowY: 'auto',
        color: '#111',
        boxShadow: '0 4px 32px rgba(0,0,0,0.18)',
        position: 'relative'
      }}>
        {/* 오른쪽 상단 버튼 */}
        <button
          className="write-button"
          style={{
            position: 'absolute',
            top: 32,
            right: detail.selected ? 32 : 122,
            background: detail.selected ? '#6ee06e' : '#636363',
            color: '#fff',
            fontWeight: 700,
            fontSize: 16,
            borderRadius: 8,
            padding: '8px 20px',
            border: 'none',
            cursor: detail.selected ? 'not-allowed' : 'pointer',
            opacity: detail.selected ? 0.7 : 1,
            boxShadow: '0 2px 8px rgba(0,0,0,0.10)'
          }}
          disabled={detail.selected || selecting}
          onClick={() => setShowConfirm(true)}
        >
          {detail.selected ? '현재 실행 모델' : '실행 모델로 선택'}
        </button>
        {/* 삭제 버튼: selected가 false일 때만 노출 */}
        {!detail.selected && (
          <button
            className="write-button"
            style={{
              position: 'absolute',
              top: 32,
              right: 30,
              background: '#FF4B4B',
              color: '#fff',
              fontWeight: 700,
              fontSize: 16,
              borderRadius: 8,
              padding: '8px 20px',
              border: 'none',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(0,0,0,0.10)'
            }}
            onClick={() => setShowDeleteConfirm(true)}
          >
            삭제
          </button>
        )}
        <div style={{ fontSize: 28, fontWeight: 700, marginBottom: 32, color: '#222', letterSpacing: 1 }}>Ver {detail.version_name || detail.version || '1.2.3'}</div>
        <div className="header-section" style={{ marginBottom: 0, marginTop: 0, gap: 0 }}>
          <div
            onClick={() => setTab('dataset')}
            className="button"
            style={{
              flex: 1,
              background: tab === 'dataset' ? '#f1f1f1' : '#fff',
              color: tab === 'dataset' ? '#222' : '#888',
              borderTopLeftRadius: 16,
              borderTopRightRadius: 0,
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              borderBottom: tab === 'dataset' ? 'none' : '2px solid #ddd',
              fontWeight: 700,
              fontSize: 18,
              padding: '14px 0',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'background 0.2s',
            }}
          >학습 데이터셋</div>
          <div
            onClick={() => setTab('param')}
            className="button"
            style={{
              flex: 1,
              background: tab === 'param' ? '#f1f1f1' : '#fff',
              color: tab === 'param' ? '#222' : '#888',
              borderTopLeftRadius: 0,
              borderTopRightRadius: 16,
              borderBottom: tab === 'param' ? 'none' : '2px solid #ddd',
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              fontWeight: 700,
              fontSize: 18,
              padding: '14px 0',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'background 0.2s',
            }}
          >하이퍼파라미터</div>
        </div>
        <div className="table-container" style={{ marginBottom: 32, marginTop: 0, background: '#fff', border: '1px solid #ddd', borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
          <div className="header-row" style={{ gridTemplateColumns: tab === 'dataset' ? '18% 18% 30% 20%' : '50% 50%', background: '#f1f1f1', color: '#222', fontWeight: 600, fontSize: 16, borderBottom: '2px solid #bbb' }}>
            {tab === 'dataset' ? (
              <>
                <span>데이터셋 이름</span>
                <span>파일 크기</span>
                <span>업로드한 사람</span>
                <span>선택 여부</span>
              </>
            ) : (
              <>
                <span>파라미터명</span>
                <span>설정값</span>
              </>
            )}
          </div>
          <div className="data-entries" style={{ maxHeight: 320, minWidth: 520 }}>
            {tab === 'dataset'
              ? datasets.map((ds, i) => (
                  <div
                    key={i}
                    className="table-row"
                    style={{ gridTemplateColumns: '18% 18% 30% 20%', background: i % 2 === 0 ? '#fff' : '#f9f9f9', color: '#111' }}
                  >
                    <span className="cell">{ds.name}</span>
                    <span className="cell">{ds.size}GB</span>
                    <span className="cell">{ds.uploaderName}</span>
                    <span className="cell" style={{ fontSize: 22 }}>
                      {selectedIds.includes(String(ds.datasetId)) ? (
                        <span style={{ color: '#6ee06e' }}>✔️</span>
                      ) : (
                        <span style={{ color: '#F30F13' }}>❌</span>
                      )}
                    </span>
                  </div>
                ))
              : paramEntries.map(([key, value], i) => (
                  <div
                    key={i}
                    className="table-row"
                    style={{ gridTemplateColumns: '50% 50%', background: i % 2 === 0 ? '#fff' : '#f9f9f9', color: '#111' }}
                  >
                    <span className="cell">{key}</span>
                    <span className="cell">{value}</span>
                  </div>
                ))}
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button
            className="button"
            style={{padding: '10px 40px'}}
            onClick={onClose}
          >확인</button>
        </div>
        {selectError && (
          <ErrorPopup
            message={selectError}
            onClose={() => setSelectError(null)}
          />
        )}
        {selectSuccess && (
          <ErrorPopup
            message="실행 모델로 선택되었습니다!"
            onClose={() => {
              setSelectSuccess(false);
              navigate('/ai-models/versions', { replace: true });
              window.location.reload();
            }}
          />
        )}
        {showConfirm && (
          <ConfirmPopup
            message="실행 모델로 선택하시겠습니까?"
            onConfirm={handleSelectModel}
            onCancel={() => setShowConfirm(false)}
          />
        )}
        {showDeleteConfirm && (
          <ConfirmPopup
            message="해당 모델을 삭제하시겠습니까?"
            onConfirm={handleDeleteModel}
            onCancel={() => setShowDeleteConfirm(false)}
          />
        )}
        {deleteSuccess && (
          <ErrorPopup
            message="모델 삭제에 성공하였습니다!"
            onClose={() => window.location.reload()}
          />
        )}
      </div>
    </div>
  );
}

export default ModelDetailModal;